import { render } from "./todayKpis.vue?vue&type=template&id=4240484c"
import script from "./todayKpis.vue?vue&type=script&lang=js"
export * from "./todayKpis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__